import React, { Component } from 'react'
import ReactTable from 'react-table'
import { Link } from 'react-router-dom'
import {
  Button,
  Form,
  Modal,
  Popconfirm,
  Radio,
  Input,
  AutoComplete,
  Select,
  DatePicker,
  Upload,
  Icon,
  message,
  Spin,
  Tooltip
} from 'antd'
import CurrencyInput from 'react-currency-input'
import moment from 'moment'
import numeral from 'numeral'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import Loader from '../../common/Loader'
import { actions as auditActions } from '../../../redux/modules/auditActions'
import { actions as paymentRequestactions } from '../../../redux/modules/jobFunctions/jobPaymentRequestActions'
import { actions as vendorActions } from '../../../redux/modules/jobFunctions/jobVendorActions'
import { actions as organizationsActions } from '../../../redux/modules/organizationsActions'
import styled from 'styled-components'
import { convertToOption, filterCaseInsensitive, getModalId } from '../../../util'
import history from '../../../history'
import { capitalize } from '../../../util'
import _ from 'lodash'
import Notes from '../../../components/notes/Notes'
import OrganizationQuickAdd from '../../../components/organization/OrganizationQuickAdd'

const FilesUploadContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  -webkit-box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
  -moz-box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
  box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
`

const EditAttachmentContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  background-color: #eeeeee;
`
const EditAttachmentTitle = styled.h6`
  color: #fff;
`
const EditingFileContainer = styled.div`
  margin: 10px 0;
`

const FormItem = Form.Item
const RadioButton = Radio.Button
const RadioGroup = Radio.Group
const { TextArea } = Input
const Option = Select.Option
const propTypes = {}

class JobPaymentRequests extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsShowing: false,
      currentId: getModalId(props.location.pathname),
      contentData: null,
      statusCut: false,
      quickAddModalVisibility: false,
      selectedRevision: 0
    }
  }

  componentDidMount() {
    // define user id to get payment requests
    let userId = 0
    if (this.props.user.isAdmin) {
      userId = this.props.selectedUser && this.props.fromDashboard ? this.props.selectedUser : 0
    } else {
      userId = this.props.fromDashboard ? this.props.user.userId : 0
    }

    this.props.jobPaymentRequestsRefresh({
      jobId: this.props.fromDashboard ? 0 : this.props.jobId,
      assignedToId: userId,
      fromDashboard: this.props.fromDashboard ? true : false,
      next: payload => {
        if (this.shouldRenderModal()) {
          const selectedPR =
            payload.data && payload.data.find(d => String(d.id) === String(this.state.currentId))
          this.props.getPaymentRequestAttachments({
            paymentRequestId: selectedPR.id
          })
          this.props.getPaymentRequestNote({
            paymentRequestId: selectedPR.id
          })
          this.setState({
            modalVisible: true,
            currentId: selectedPR.id,
            contentData: selectedPR
          })
          this.props.getAuditRevisions({
            targetId: selectedPR.id,
            table: 'payment_request'
          })
        }
      }
    })
    this.props.getAllVendors()
    if (this.props.shortcutItemId && this.props.jobPaymentRequestActions.jobPaymentRequests) {
      const highLightEstimate = _.filter(
        this.props.jobPaymentRequestActions.jobPaymentRequests &&
          this.props.jobPaymentRequestActions.jobPaymentRequests.data,
        paymentRequest => paymentRequest.id === parseInt(this.props.shortcutItemId, 10)
      )
      this.handleRowClick(highLightEstimate[0])
    }
    if (this.props.clearHighlight) {
      this.props.clearHighlight()
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.loadingRevision !== this.props.loadingRevision) {
      const { revisions } = this.getRevisions()

      if (revisions) {
        this.setState({
          currentRevisionNumberPrint: revisions[revisions.length - 1].currentRevisionNumber
        })
      }
    }
  }

  componentDidUpdate(prevProps) {
    const { selectedUser } = this.props
    if (selectedUser !== prevProps.selectedUser) {
      this.props.jobPaymentRequestsRefresh({
        jobId: this.props.fromDashboard ? 0 : this.props.jobId,
        assignedToId: this.props.selectedUser ? this.props.selectedUser : 0,
        fromDashboard: this.props.fromDashboard ? true : false
      })
    }
  }

  shouldRenderModal = () => {
    return /modal\/\d+$/.test(window.location.href)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.auditActions.revisions !== nextProps.auditActions.revisions) {
      const last = _.last(nextProps.auditActions.revisions.data)
      if (last !== undefined) {
        this.setState({
          selectedRevision: last.revision - 1
        })
      }
    }
  }

  handleRevisionChange = revisionNumber => {
    const { form } = this.props
    const allVendors = this.props.jobVendorActions.allVendors.data
    const revisions = this.getRevisions()

    const revision = revisions[revisionNumber]

    this.setState({
      selectedRevision: revisionNumber
    })

    let changes = {}
    const jsonPatch = JSON.parse(revision.json_patch)
    jsonPatch.forEach(op => {
      if (op.path === '/0') {
        changes = op.value
        for (const key in changes) {
          if (/_date$/.test(key)) {
            changes[key] = moment(changes[key])
          } else if (key === 'payable_to_id') {
            // eslint-disable-next-line no-loop-func
            changes[key] = allVendors.find(f => f.id === changes[key]).name
          } else if (key === 'status') {
            changes[key] = capitalize(changes[key])
          }
        }
      } else {
        const fieldName = op.path.substring(1, op.path.length)
        changes[fieldName] = op.value
        if (/_date$/.test(fieldName)) {
          changes[fieldName] = moment(changes[fieldName])
        } else if (fieldName === 'payable_to_id') {
          // eslint-disable-next-line no-loop-func
          changes[fieldName] = allVendors.find(f => f.id === changes[fieldName]).name
        } else if (fieldName === 'status') {
          changes[fieldName] = capitalize(op.value)
        }
      }
    })
    form.setFieldsValue(changes)
  }

  handleBlurOrganization = organization => {
    const allVendors = this.props.jobVendorActions.allVendors.data
    if (organization !== '') {
      this.setState({
        quickAddModalVisibility:
          _.findIndex(allVendors, { id: +organization }) < 0 &&
          _.findIndex(allVendors, { name: organization }) < 0
            ? true
            : false
      })
    }
  }

  handleCancelQuickAdd = () => {
    this.setState({
      quickAddModalVisibility: !this.state.quickAddModalVisibility
    })
  }

  showModal = () => {
    this.setState({
      modalVisible: true
    })
  }

  handleRowClick = row => {
    this.setState(
      {
        modalVisible: true,
        currentId: row.id,
        contentData: row
      },
      () => {
        this.props.getPaymentRequestAttachments({
          paymentRequestId: row.id
        })
        this.props.getPaymentRequestNote({
          paymentRequestId: row.id
        })
        this.props.getAuditRevisions({
          targetId: row.id,
          table: 'payment_request'
        })
        const { jobType, jobId } = this.props.match.params
        history.push(`/jobView/${jobId}/${jobType}/payment-requests/modal/${row.id}`)
        this.forceUpdate()
      }
    )
  }

  handleAddButton = () => {
    this.setState(
      {
        modalVisible: true,
        currentId: 0,
        contentData: null
      },
      () => {
        const { jobType, jobId } = this.props.match.params
        history.push(`/jobView/${jobId}/${jobType}/payment-requests/modal/0`)
        this.forceUpdate()
      }
    )
  }

  redirectToPRs = () => {
    const { jobType, jobId } = this.props.match.params
    history.push(`/jobView/${jobId}/${jobType}/payment-requests`)
    this.forceUpdate()
  }

  handleCancel = () => {
    this.props.form.resetFields()
    this.setState({ data: [], currentId: 0, modalVisible: false }, this.redirectToPRs)
  }

  getSelectedPayableTo = value => {
    const vendors =
      this.props.jobVendorActions &&
      this.props.jobVendorActions.allVendors &&
      this.props.jobVendorActions.allVendors.data
    const selectedVendor = vendors.find(vendor => vendor.name === value)
    return selectedVendor ? +selectedVendor.id : +value
  }

  handleCreate = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }

      Object.keys(values).forEach(function(key, value) {
        if (key === 'due_date') {
          if (moment(values[key]).isValid()) {
            values[key] = values[key].format('YYYY-MM-DD hh:mm:ss')
          } else {
            values[key] = null
          }
        }
      })

      // sanitize job and employee autocomplete field
      values.payable_to_id = this.getSelectedPayableTo(values.payable_to_id)

      if (_.isString(values.amount)) {
        const amount = values.amount
        let amountFormatted = amount.replace('$', '')
        amountFormatted = amountFormatted.replace(',', '')
        values.amount = amountFormatted
      }

      if (this.state.currentId === 0) {
        this.props.createJobPaymentRequest({
          created_by_id: this.props.user.userId,
          updated_by_id: this.props.user.userId,
          job_id: this.props.jobId,
          due_date: values.due_date,
          payment_type: values.type,
          payable_from: values.payable_from,
          payable_to_id: values.payable_to_id,
          description: values.description,
          amount: values.amount
        })
      } else {
        if (values.status !== 'Cut') {
          values.check_number = null
        }
        this.props.updateJobPaymentRequest({
          jobId: this.props.jobId,
          paymentRequestId: this.state.currentId,
          content: values,
          created_by_id_payment_request: this.state.contentData.created_by_id,
          userId: this.props.user.userId
        })
      }

      form.resetFields()
      message.success('Changes saved.')
      this.setState({ contentData: null, currentId: 0, modalVisible: false }, this.redirectToPRs)
    })
  }

  confirmDelete = event => {
    const form = this.props.form

    this.props.deleteJobPaymentRequest({
      jobId: this.props.jobId,
      paymentRequestId: this.state.currentId
    })

    form.resetFields()
    message.success('Record deleted.')
    this.setState(
      {
        contentData: null,
        currentId: 0,
        modalVisible: false
      },
      this.redirectToPRs
    )
  }

  handleVendorChange = event => {
    const form = this.props.form
    const selectedVendor = this.props.jobVendorActions.allVendors.data.filter(
      row => parseInt(row.id, 0) === parseInt(event, 0)
    )
    if (selectedVendor.length > 0) {
      form.setFieldsValue({
        requested_by: `${selectedVendor[0].created_by_first_name} ${
          selectedVendor[0].created_by_last_name
        }`,
        description: selectedVendor[0].description,
        work_order_template_id: selectedVendor[0].id
      })
    }
  }

  uploadAttachment = uploadParam => {
    const formData = new FormData()

    formData.append('file', uploadParam.file)
    formData.append('type', 'payment_request')
    formData.append('created_by_id', this.props.user.userId)
    formData.append('updated_by_id', this.props.user.userId)
    formData.append('filename', uploadParam.file.name)
    formData.append('description', uploadParam.file.name)
    formData.append('paymentRequestId', this.state.currentId)

    this.props.uploadPaymentRequestAttachment({
      formData: formData,
      paymentRequestId: this.state.currentId
    })
  }

  handleAttachmentRowClick = row => {
    this.setState({
      attachmentDetailsVisible: true,
      attachmentId: row.id,
      attachmentName: row.filename,
      attachmentDescription: row.description
    })
  }

  onDescriptionChange = e => {
    this.setState({
      attachmentDescription: e.target.value
    })
  }

  handleUpdateAttachmentDescription = () => {
    this.props.updatePaymentRequestAttachmentDescription({
      description: this.state.attachmentDescription,
      attachmentId: this.state.attachmentId,
      paymentRequestId: this.state.currentId,
      userId: this.props.user.userId
    })
    this.setState({
      attachmentDetailsVisible: false
    })
  }

  confirmAttachmentDelete = event => {
    this.props.deletePaymentRequestAttachment({
      attachmentId: this.state.attachmentId,
      paymentRequestId: this.state.currentId
    })
    this.setState({
      attachmentDetailsVisible: false
    })
  }

  // notes things
  handleToggleNoteEditArea = () => {
    if (this.state.currentNote) {
      this.setState({
        currentNote: null,
        currentNoteId: null,
        noteAddEditContainer: true
      })
    } else {
      this.setState({
        noteAddEditContainer: !this.state.noteAddEditContainer
      })
    }
  }

  createNote = params => {
    this.props.createPaymentRequestNote({
      content: params,
      userId: this.props.user.userId,
      paymentRequestId: this.state.currentId
    })

    this.handleToggleNoteEditArea()
  }

  updateNote = params => {
    this.props.editPaymentRequestNote({
      content: params,
      noteId: this.state.currentNoteId,
      paymentRequestId: this.state.currentId
    })

    this.handleToggleNoteEditArea()

    this.setState({
      currentNote: null,
      currentNoteId: null
    })
  }

  deleteNote = () => {
    this.props.deletePaymentRequestNote({
      noteId: this.state.currentNoteId,
      paymentRequestId: this.state.currentId
    })

    this.handleToggleNoteEditArea()

    this.setState({
      currentNote: null,
      currentNoteId: null,
      noteAddEditContainer: false
    })
  }

  handleRowNoteClick = row => {
    this.setState({
      noteAddEditContainer: true,
      currentNote: row,
      currentNoteId: row.id
    })
  }

  handleQuickAddOrganization = organization => {
    this.props.quickAddNewOrganization({
      organization: organization,
      userId: this.props.user.userId
    })
  }
  onStatusChange = e => {
    this.setState({
      statusCut: e.target.value === 'Cut' ? true : false
    })
  }

  getRevisions() {
    return (
      this.props.auditActions &&
      this.props.auditActions.revisions &&
      this.props.auditActions.revisions.data
    )
  }

  render() {
    const { contentData } = this.state

    const { fromDashboard } = this.props
    const { loading } = this.props.auditActions
    const revisions = this.getRevisions()

    const uploadProps = {
      multiple: true,
      fileList: this.state.fileList
    }

    const { getFieldDecorator } = this.props.form

    const currentRevision =
      _.has(revisions, this.state.selectedRevision) && revisions[this.state.selectedRevision]

    if (!this.props.jobPaymentRequestActions.jobPaymentRequests) {
      return <Loader />
    }
    return (
      <div>
        <OrganizationQuickAdd
          modalVisible={this.state.quickAddModalVisibility}
          handleCancel={this.handleCancelQuickAdd}
          handleQuickAddOrganization={this.handleQuickAddOrganization}
          organizartionType={'Vendor'}
        />
        {this.shouldRenderModal() && (
          <Modal
            visible={true}
            title="Payment Request"
            okText={contentData ? 'Save Changes' : 'Create'}
            onCancel={this.handleCancel}
            onOk={this.handleCreate}
            width={contentData ? '90%' : '40%'}
            maskClosable={false}
          >
            {contentData && (
              <div className="row">
                <div className="col-3">
                  <FormItem label="Revision">
                    {loading ? (
                      <Spin size="small" />
                    ) : (
                      <Select
                        value={this.state.selectedRevision}
                        onChange={this.handleRevisionChange}
                      >
                        {revisions &&
                          revisions.map(revision => (
                            <Option
                              key={revision.revision}
                              value={revision.revision - 1} // revision index
                            >
                              {revision.revision}
                            </Option>
                          ))}
                      </Select>
                    )}
                  </FormItem>
                </div>
              </div>
            )}
            {contentData && (
              <div className="row">
                <div className="col-md-12">
                  <h4>Payment Request #{contentData.id}</h4>
                </div>
              </div>
            )}
            <Form layout="vertical">
              <div className="row">
                {contentData && (
                  <div className="col-md-6">
                    <FormItem label="Created By">
                      {`${contentData.created_by_first_name} ${contentData.created_by_last_name}`}
                    </FormItem>
                  </div>
                )}
                {currentRevision &&
                  contentData && (
                    <div className="col-md-6">
                      <FormItem label="Updated By">
                        {`${currentRevision.created_by_first_name} ${
                          currentRevision.created_by_last_name
                        }`}
                      </FormItem>
                    </div>
                  )}
              </div>
              <div className="row">
                {contentData && (
                  <div className="col-md-6">
                    <FormItem label="Created Date">
                      {moment(contentData.created_date).format('M/D/YYYY')}
                    </FormItem>
                  </div>
                )}
                {contentData &&
                  currentRevision && (
                    <div className="col-md-6">
                      <FormItem label="Updated Date">
                        {moment(currentRevision.updated_date).format('M/D/YYYY')}
                      </FormItem>
                    </div>
                  )}
              </div>
              <div className="row">
                <div className="col-md-6">
                  {contentData && (
                    <FormItem label="Status">
                      {getFieldDecorator('status', {
                        initialValue: contentData ? contentData.status : ''
                      })(
                        <RadioGroup onChange={this.onStatusChange}>
                          <RadioButton value="Created">Created</RadioButton>
                          <RadioButton value="Approved">Approved</RadioButton>
                          <RadioButton value="Rejected">Rejected</RadioButton>
                          <RadioButton value="Cut">Cut</RadioButton>
                          <RadioButton value="Processed">Processed</RadioButton>
                        </RadioGroup>
                      )}
                    </FormItem>
                  )}
                </div>
                <div className="col-md-6">
                  {contentData &&
                    this.state.statusCut && (
                      <FormItem label="Check Number">
                        {getFieldDecorator('check_number', {
                          initialValue: contentData ? contentData.check_number : ''
                        })(<Input />)}
                      </FormItem>
                    )}
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <FormItem label="Type">
                    {getFieldDecorator('type', {
                      rules: [
                        {
                          required: true,
                          message: 'Must choose a type'
                        }
                      ],
                      initialValue: contentData ? contentData.type : ''
                    })(
                      <RadioGroup>
                        <RadioButton value="Check">Check</RadioButton>
                        <RadioButton value="Credit">Credit</RadioButton>
                      </RadioGroup>
                    )}
                  </FormItem>
                </div>
                <div className="col-md-6">
                  <FormItem label="Amount">
                    {getFieldDecorator('amount', {
                      rules: [
                        {
                          required: true,
                          message: 'Amount has to be higher than zero.'
                        }
                      ],
                      initialValue: contentData && contentData.amount
                    })(<CurrencyInput className="ant-input" prefix="$" placeholder="$ 0.00" />)}
                  </FormItem>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <FormItem label="Payable to">
                    {getFieldDecorator('payable_to_id', {
                      rules: [
                        {
                          required: true,
                          message: 'You must choose a vendor.'
                        }
                      ],
                      initialValue: contentData ? contentData.company_name : ''
                    })(
                      <AutoComplete
                        dataSource={
                          this.props.jobVendorActions &&
                          this.props.jobVendorActions.allVendors &&
                          convertToOption(this.props.jobVendorActions.allVendors.data)
                        }
                        filterOption={(inputValue, option) =>
                          option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !==
                          -1
                        }
                        onChange={this.handleVendorChange}
                        onBlur={this.handleBlurOrganization}
                        placeholder="Search for a vendor"
                      >
                        <Input suffix={<Icon type="search" className="certain-category-icon" />} />
                      </AutoComplete>
                    )}
                  </FormItem>
                </div>
                <div className="col-md-6">
                  <FormItem label="Payable from">
                    {getFieldDecorator('payable_from', {
                      rules: [
                        {
                          required: true,
                          message: 'You must choose a payment source.'
                        }
                      ],
                      initialValue: contentData ? contentData.payable_from : ''
                    })(
                      <Select>
                        <Option value="Chase - Operating">Chase - Operating</Option>
                        <Option value="Chase - Payroll">Chase - Payroll</Option>
                        <Option value="Chase - Health">Chase - Health</Option>
                        <Option value="Chase - United">Chase - United</Option>
                        <Option value="HSBC - Material">HSBC - Material</Option>
                        <Option value="Chase - Ink">Chase - Ink</Option>
                        <Option value="AMEX - Silver">AMEX - Silver</Option>
                        <Option value="AMEX - Plum">AMEX - Plum</Option>
                        <Option value="5G - Operating">5G - Operating</Option>
                        <Option value="Other">Other</Option>
                      </Select>
                    )}
                  </FormItem>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <FormItem label="Due date">
                    {getFieldDecorator('due_date', {
                      rules: [
                        {
                          required: true,
                          message: 'Due date cannot be blank.'
                        }
                      ],
                      initialValue: contentData ? moment(contentData.due_date) : null
                    })(<DatePicker />)}
                  </FormItem>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <FormItem label="Memo">
                    {getFieldDecorator('description', {
                      rules: [
                        {
                          required: true,
                          message: 'Memo cannot be blank.'
                        }
                      ],
                      initialValue: contentData ? contentData.description : ''
                    })(<TextArea />)}
                  </FormItem>
                </div>
              </div>
            </Form>
            {contentData && (
              <div className="row">
                <div className="col-12">
                  <Notes
                    // notes props
                    currentNote={this.state.currentNote}
                    currentNoteId={this.state.currentNoteId}
                    notes={
                      this.props.jobPaymentRequestActions.paymentRequestNotes &&
                      this.props.jobPaymentRequestActions.paymentRequestNotes.data
                    }
                    handleToggleNoteEditArea={this.handleToggleNoteEditArea}
                    noteAddEditContainer={this.state.noteAddEditContainer}
                    createNote={this.createNote}
                    handleRowNoteClick={this.handleRowNoteClick}
                    updateNote={this.updateNote}
                    userId={this.props.user.userId}
                    deleteNote={this.deleteNote}
                  />
                </div>
              </div>
            )}
            {contentData && (
              <FilesUploadContainer>
                <div className="row">
                  <div className="col-md-6">
                    <h5>
                      <Icon type="check" /> Payment Files
                    </h5>
                  </div>
                  <div className="col-md-6 text-right">
                    {this.props.jobPaymentRequestActions &&
                      this.props.jobPaymentRequestActions.uploadingAttachment && (
                        <div className="text-success">
                          <Icon type="loading" /> Uploading File(s)
                        </div>
                      )}
                    {this.props.jobPaymentRequestActions &&
                      this.props.jobPaymentRequestActions.deletingAttachment && (
                        <div className="text-danger">
                          <Icon type="loading" /> Deleting File(s)
                        </div>
                      )}
                  </div>
                </div>
                {this.props.jobPaymentRequestActions.jobPaymentRequestsAttachments &&
                  this.props.jobPaymentRequestActions.jobPaymentRequestsAttachments.data.length >
                    0 && (
                    <Spin spinning={this.props.jobPaymentRequestActions.loadingAttachments}>
                      <ReactTable
                        defaultPageSize={5}
                        defaultFilterMethod={filterCaseInsensitive}
                        data={
                          this.props.jobPaymentRequestActions.jobPaymentRequestsAttachments.data
                        }
                        getTrProps={(state, rowInfo, column, instance) => ({
                          onClick: e => this.handleAttachmentRowClick(rowInfo.original)
                        })}
                        columns={[
                          {
                            Header: 'Attached Files',
                            columns: [
                              {
                                Header: 'Filename',
                                id: 'filename',
                                accessor: 'filename',
                                Cell: d => (
                                  <Tooltip title={d.original.filename}>
                                    {d.original.filename}
                                  </Tooltip>
                                )
                              },
                              {
                                Header: 'Description',
                                id: 'description',
                                accessor: 'description',
                                Cell: d => (
                                  <Tooltip title={d.original.description}>
                                    {d.original.description}
                                  </Tooltip>
                                )
                              },
                              {
                                Header: 'Created by',
                                id: 'created_by',
                                accessor: d => {
                                  const name = `${d.created_by_first_name} ${
                                    d.created_by_last_name
                                  }`
                                  return <Tooltip title={name}>{name}</Tooltip>
                                }
                              },
                              {
                                Header: 'Updated by',
                                id: 'updated_by',
                                accessor: d => {
                                  const name = `${d.updated_by_first_name} ${
                                    d.updated_by_last_name
                                  }`
                                  return <Tooltip title={name}>{name}</Tooltip>
                                }
                              },
                              {
                                Cell: row => (
                                  <Tooltip placement="left" title="Open this file on a new window">
                                    <a target="_blank" href={row.original.signedUrl}>
                                      <Icon type="export" className="fontSize20" />
                                    </a>
                                  </Tooltip>
                                ),
                                maxWidth: 35
                              }
                            ]
                          }
                        ]}
                        defaultSorted={[
                          {
                            id: 'id',
                            desc: true
                          }
                        ]}
                        className="-striped -highlight"
                      />
                    </Spin>
                  )}
                {this.state.attachmentDetailsVisible && (
                  <EditAttachmentContainer>
                    <EditAttachmentTitle>
                      <Icon type="edit" /> Edit Attachment Area
                    </EditAttachmentTitle>
                    <div>
                      <EditingFileContainer>
                        <Icon type="file" /> {this.state.attachmentName}
                      </EditingFileContainer>
                    </div>
                    <div className="row">
                      <div className="col-md-10">
                        <TextArea
                          placeholder="Describe the attachment..."
                          rows={4}
                          onChange={this.onDescriptionChange}
                          value={this.state.attachmentDescription}
                        />
                      </div>
                    </div>
                    <div className="d-flex flex-row mt-2">
                      <Button onClick={this.handleUpdateAttachmentDescription}>
                        <Icon type="save" /> OK
                      </Button>{' '}
                      <Popconfirm
                        title="Are you sure you want to delete this attachment?"
                        onConfirm={this.confirmAttachmentDelete}
                        okText="Yes"
                        cancelText="No"
                      >
                        <Button type="danger" icon="delete" className="ml-2">
                          {' '}
                          DELETE
                        </Button>
                      </Popconfirm>
                    </div>
                  </EditAttachmentContainer>
                )}
                <br />
                <div>Upload Payment File(s)</div>
                <br />
                <Upload {...uploadProps} name="file" customRequest={this.uploadAttachment}>
                  <Button>
                    <Icon type="upload" /> Upload
                  </Button>
                </Upload>
              </FilesUploadContainer>
            )}
            <Popconfirm
              title="Are you sure you want to delete this record?"
              onConfirm={this.confirmDelete}
              onCancel={this.cancelDelete}
              okText="Yes"
              cancelText="No"
            >
              {contentData && <Button type="danger" icon="delete" />}
            </Popconfirm>
          </Modal>
        )}
        <div className="jobsBar">
          Payment Requests
          {!this.props.fromDashboard && (
            <div className="jobsBarAdd">
              <i className="fa fa-plus-square" aria-hidden="true" />
              &nbsp;<div onClick={() => this.handleAddButton()} className="addJobLabel">
                ADD Request
              </div>
            </div>
          )}
        </div>
        {/* Table for job > payment requests */}
        {this.props.jobPaymentRequestActions.jobPaymentRequests &&
          !fromDashboard && (
            <ReactTable
              filterable
              defaultFilterMethod={filterCaseInsensitive}
              getTrProps={(state, rowInfo, column, instance) => ({
                onClick: e => this.handleRowClick(rowInfo.original)
              })}
              data={this.props.jobPaymentRequestActions.jobPaymentRequests.data}
              columns={[
                {
                  columns: [
                    {
                      Header: '#',
                      accessor: 'id',
                      minWidth: 40
                    },
                    {
                      Header: 'Due Date',
                      id: 'due_date',
                      accessor: 'due_date',
                      Cell: row => {
                        const r = moment.utc(row.value).format('M/D/YYYY')
                        return <Tooltip title={r}>{r}</Tooltip>
                      },
                      minWidth: 70
                    },
                    {
                      Header: 'Type',
                      id: 'type',
                      accessor: 'type',
                      maxWidth: 150,
                      Cell: d => <Tooltip title={d.original.type}>{d.original.type}</Tooltip>
                    },
                    {
                      Header: 'Amount',
                      id: 'amount',
                      accessor: 'amount',
                      Cell: d => {
                        const r = numeral(d.original.amount).format('$0,0.00')
                        return <Tooltip title={r}>{r}</Tooltip>
                      }
                    },
                    {
                      Header: 'Payable To',
                      id: 'company_name',
                      accessor: 'company_name',
                      Cell: d => (
                        <Tooltip title={d.original.company_name}>
                          <Link
                            to={
                              d.original.company_type === 'Vendor'
                                ? `/vendors/${d.original.company_id}`
                                : `/companies/${d.original.company_id}`
                            }
                          >
                            {d.original.company_name}
                          </Link>
                        </Tooltip>
                      )
                    },
                    {
                      Header: 'Payable From',
                      id: 'payable_from',
                      accessor: 'payable_from',
                      Cell: d => (
                        <Tooltip title={d.original.payable_from}>{d.original.payable_from}</Tooltip>
                      )
                    },
                    {
                      Header: 'Created By',
                      id: 'created_by',
                      accessor: d => `${d.created_by_first_name} ${d.created_by_last_name}`,
                      Cell: d => {
                        const r = `${d.original.created_by_first_name} ${
                          d.original.created_by_last_name
                        }`
                        return <Tooltip title={r}>{r}</Tooltip>
                      },
                      width: 160
                    },
                    {
                      Header: 'Updated By',
                      id: 'updated_by',
                      accessor: d => `${d.updated_by_first_name} ${d.updated_by_last_name}`,
                      Cell: d => {
                        const r = `${d.original.updated_by_first_name} ${
                          d.original.updated_by_last_name
                        }`
                        return <Tooltip title={r}>{r}</Tooltip>
                      },
                      width: 160
                    },
                    {
                      Header: 'Status',
                      accessor: 'status',
                      maxWidth: 120
                    }
                  ]
                }
              ]}
              defaultSorted={[
                {
                  id: 'id',
                  desc: true
                }
              ]}
              defaultPageSize={10}
              className="-striped -highlight"
            />
          )}
        {/* Table for dashboard > payment requests */}
        {this.props.jobPaymentRequestActions.jobPaymentRequests &&
          fromDashboard && (
            <ReactTable
              filterable
              defaultFilterMethod={filterCaseInsensitive}
              getTdProps={(state, rowInfo, column, instance) => ({
                onClick: e => {
                  if (column.Header !== 'Job') {
                    this.handleRowClick(rowInfo.original)
                  }
                }
              })}
              data={this.props.jobPaymentRequestActions.jobPaymentRequests.data}
              columns={[
                {
                  columns: [
                    {
                      Header: 'Job',
                      accessor: 'job_id',
                      Cell: row => {
                        const r = `${row.original.job_id} - ${row.original.job_name}`
                        return (
                          <Tooltip title={r}>
                            <Link to={`/jobView/${row.original.job_id}/${row.original.job_type}`}>
                              {r}
                            </Link>
                          </Tooltip>
                        )
                      },
                      minWidth: 150
                    },
                    {
                      Header: 'Due Date',
                      id: 'due_date',
                      accessor: 'due_date',
                      Cell: row => {
                        const r = moment.utc(row.value).format('M/D/YYYY')
                        return <Tooltip title={r}>{r}</Tooltip>
                      },
                      minWidth: 70
                    },
                    {
                      Header: 'Type',
                      id: 'type',
                      accessor: 'type',
                      maxWidth: 150,
                      Cell: d => <Tooltip title={d.original.type}>{d.original.type}</Tooltip>
                    },
                    {
                      Header: 'Amount',
                      id: 'amount',
                      accessor: 'amount',
                      Cell: d => {
                        const r = numeral(d.original.amount).format('$0,0.00')
                        return <Tooltip title={r}>{r}</Tooltip>
                      }
                    },
                    {
                      Header: 'Payable To',
                      id: 'company_name',
                      accessor: 'company_name',
                      Cell: d => (
                        <Tooltip title={d.original.company_name}>
                          <Link
                            to={
                              d.original.company_type === 'Vendor'
                                ? `/vendors/${d.original.company_id}`
                                : `/companies/${d.original.company_id}`
                            }
                          >
                            {d.original.company_name}
                          </Link>
                        </Tooltip>
                      )
                    },
                    {
                      Header: 'Payable From',
                      id: 'payable_from',
                      accessor: 'payable_from',
                      Cell: d => (
                        <Tooltip title={d.original.payable_from}>{d.original.payable_from}</Tooltip>
                      )
                    },
                    {
                      Header: 'Created By',
                      id: 'created_by',
                      accessor: d => `${d.created_by_first_name} ${d.created_by_last_name}`,
                      Cell: d => {
                        const r = `${d.original.created_by_first_name} ${
                          d.original.created_by_last_name
                        }`
                        return <Tooltip title={r}>{r}</Tooltip>
                      },
                      width: 160
                    },
                    {
                      Header: 'Updated By',
                      id: 'updated_by',
                      accessor: d => `${d.updated_by_first_name} ${d.updated_by_last_name}`,
                      Cell: d => {
                        const r = `${d.original.updated_by_first_name} ${
                          d.original.updated_by_last_name
                        }`
                        return <Tooltip title={r}>{r}</Tooltip>
                      },
                      width: 160
                    },
                    {
                      Header: 'Status',
                      accessor: 'status',
                      maxWidth: 120
                    }
                  ]
                }
              ]}
              defaultSorted={[
                {
                  id: 'id',
                  desc: true
                }
              ]}
              defaultPageSize={10}
              className="-striped -highlight"
            />
          )}
      </div>
    )
  }
}

const mapStateToProps = ({
  jobPaymentRequestActions,
  jobVendorActions,
  organizationsActions,
  auditActions
}) => ({
  jobPaymentRequestActions,
  jobVendorActions,
  organizationsActions,
  auditActions
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(
    Object.assign({}, paymentRequestactions, vendorActions, organizationsActions, auditActions),
    dispatch
  )
})

JobPaymentRequests.propTypes = propTypes
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Form.create()(JobPaymentRequests))
)



// WEBPACK FOOTER //
// ./src/containers/job/tasks/JobPaymentRequests.js